import React from "react"

const Loader = () => {

    return (
        <div id="loader">
            <div class="lds-dual-ring"></div>
            <p>
                Patientez pendant le chargement de l'application qui peut durer environ 2 minutes, suivant la qualité de votre connexion.
            </p>
        </div>
    )
}

export default Loader